import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import Routes from '../src/riskwell/Routes/Routes';
import * as actionCreators from './riskwell/Action/login';
import IdleTimerContainer from './riskwell/Components/Tenant/Component/IdlTimeOut';
class App extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
  }

  render() {
    return (
      <div>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
        <IdleTimerContainer></IdleTimerContainer>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = state => {
  return ({
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

